import React, { useState } from 'react';
import { AdStudioHome } from './AdStudioHome';
import { AdStudioEditor } from './AdStudioEditor';
import { CreativeSet } from '../data/adStudio';
export function DemandAdStudio({
  selectedOwner = ''
}: {
  selectedOwner?: string;
}) {
  const [openSet, setOpenSet] = useState<CreativeSet | null>(null);
  if (openSet) {
    return <AdStudioEditor set={openSet} onBack={() => setOpenSet(null)} data-id="element-689" data-mp="zznnjfuzmv1p" />;
  }
  return <AdStudioHome selectedOwner={selectedOwner} onOpen={setOpenSet} data-id="element-690" data-mp="1wnbt6ydv4v4d" />;
}